import apiClient from "./APIClient";

export const getCountries = () => {
  return apiClient.get('/country?lang=en').then(r => r.data);
};

export const getGameCategories = () => {
  return apiClient.get('/productCategory/games/all?lang=en').then(r => r.data);
};

export const getGameTypes = () => {
  return apiClient.get('/productTypes/games/all?lang=en').then(r => r.data);
};

export const getProviders = async () => {
  try {
    const lang = localStorage.getItem("i18nextLng");
    const res = await apiClient.get(`companies?lang=${lang}`);
    console.log(res, "this is providers data");
    return res.data?.data;
  } catch (error) {
    console.log("Error fetching providers:", error);
    throw error;
  }
};

export const getProducts = (filters = {}) => {
  const params = new URLSearchParams();
  params.append('lang', 'en');
  
  if (filters.countryId) {
    params.append('countryId', filters.countryId);
  }
  if (filters.productCategoryId) {
    params.append('productCategoryId', filters.productCategoryId);
  }
  if (filters.productTypeId) {
    params.append('productTypeId', filters.productTypeId);
  }
  if (filters.search) {
    params.append('search', filters.search);
  }
  
  params.append('_t', Date.now());
  params.append('fresh', 'true');
  
  return apiClient.get(`/product/agent/games?${params.toString()}`).then(r => r?.data);
};

export const getSingleProduct = (productId) => {
  const params = new URLSearchParams();
  params.append('lang', 'en');
  
  return apiClient.get(`/product/admin/${productId}?${params.toString()}`).then(r => r?.data);
};

export const activateGameBundle = (payload = {}) => {
  return apiClient.post(`/game-activation/agent-activate?lang=en`, payload).then(r => r?.data);
};

export const getOrderStatus = async (orderId) => {
  try {
    const response = await apiClient.get(`/orders/${orderId}`);
    return response.data;
  } catch (error) {
    console.error('Get order status API error:', error);
    throw error;
  }
};